import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { ElementService } from '../../../../services/element.service';
import { Element } from '../../../../models/element.model';
import { FormGroup, Validators, FormControl } from '@angular/forms';

import { GroupService } from '../../../../services/group.service';
import { MediaAttributeService } from '../../../../services/media-attribute.service';
import { DepartmentService } from '../../../../services/department.service';
import { ClientService } from '../../../../services/client.service';
import { Subscription } from 'rxjs/Subscription';
import { Group } from '../../../../models/group.model';
import { MediaAttribute } from '../../../../models/media-attribute.model';
import { Department } from '../../../../models/department.model';
import { Client } from '../../../../models/client.model';

import { Select2OptionData } from 'ng2-select2';

@Component({
  selector: 'app-element-edit',
  templateUrl: './element-edit.component.html',
  styleUrls: ['./element-edit.component.css']
})
export class ElementEditComponent implements OnInit, OnDestroy {
  loading = false;
  id: number;
  editMode = false;
  backUrl: string;
  category: string;
  category_id: number;
  block: string;
  block_id: number;
  duplicateMode = false;
  htmlHolder: any;
  blockHolder: any;
  categoryHolder: any;

  subscription: Subscription;
  subscriptionGroup: Subscription;
  subscriptionMediaAttribute: Subscription;
  subscriptionDepartment: Subscription;
  subscriptionClient: Subscription;
  subscriptionResponse: Subscription;
  subscriptionElements: Subscription;

  categories = {
    'enewsletter': 1,
    'buyer-match': 2,
    'quick-enquiry': 3,
    'brochure': 4,
    'property-guide': 5,
    'social-media': 6,
    'email-signature': 7,
    'dl-card': 8,
    'sign-board': 9
  };

  elementForm: FormGroup;
  element: Element;
  elements: Element[];

  groups: Group[];
  mediaAttributes: MediaAttribute[];
  departments: Department[];
  clients: Client[];

  element_title = '';
  element_icon = '';
  element_thumbnail = '';

  s3_resource_path = '';

  s2ClientValue = 0;
  s2ClientData: Array<Select2OptionData>;
  s2ClientOptions: Select2Options;

  s2GroupValue = 0;
  s2GroupData: Array<Select2OptionData>;
  s2GroupOptions: Select2Options;

  aceEditor: any;
  scriptEditor: any;

  @ViewChild('fileIcon') fileIcon: ElementRef;
  @ViewChild('fileThumbnail') fileThumbnail: ElementRef;

  constructor(private elementService: ElementService,
              private groupService: GroupService,
              private mediaAttributeService: MediaAttributeService,
              private departmentService: DepartmentService,
              private clientService: ClientService,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {
    this.route.params.subscribe(
      (params: Params) => {
        this.id = +params['id'];
        this.duplicateMode = params['dupe'];
        this.editMode = params['id'] != null;
        if (this.duplicateMode) {
          this.backUrl = '../../../';
        } else {
          this.backUrl = this.editMode ? '../../' : '../../';
        }

        this.category = params['type'];
        this.category_id = this.categories[this.category];
        this.block_id = params['block'];

        if (this.id) {
          this.loading = true;

          this.elementService.httpGetElement(this.id);
        } else {
          this.elementService.httpGetElements(
            {
              parent_id: 0,
              category_id: this.category_id,
              block_id: this.block_id
            },
            '',
            ''
          );
        }
      }
    );

    this.groupService.httpGetGroups();
    this.mediaAttributeService.httpGetMediaAttributes();
    this.departmentService.httpGetDepartments();
    this.clientService.httpGetClients({}, 'list');

    this.subscriptionGroup = this.groupService.groupsChanged.subscribe(
      (groups: Group[]) => {
        this.groups = groups;

        if ( this.groups.length > 0 ) {
          this.s2GroupData =  <any>groups.map(
            (obj) => {
              return {id: obj.ID, text: `${obj.ID} ${obj.title}`};
            }
          );
        }
      }
    );

    this.subscriptionMediaAttribute = this.mediaAttributeService.mediaAttributesChanged.subscribe(
      (mediaAttributes: MediaAttribute[]) => {
        this.mediaAttributes = mediaAttributes;
      }
    );

    this.subscriptionDepartment = this.departmentService.departmentsChanged.subscribe(
      (departments: Department[]) => {
        this.departments = departments;
      }
    );

    this.subscriptionClient = this.clientService.clientsChanged.subscribe(
      (clients: Client[]) => {
        if (clients.length > 0) {
          this.clients = clients;
          this.s2ClientData =  <any>clients.map(
            (obj) => {
              return {id: obj.ID, text:  (obj.name ? obj.name : obj.company_name) + ' (' + obj.office_id + ')'};
            }
          );
          this.s2ClientData.unshift({id: '0', text: 'All'});

        }
      }
    );

    this.s2ClientOptions = {
      width: '100%',
      placeholder: 'Select a Client'
    };

    this.s2GroupOptions = {
      width: '100%',
      placeholder: 'Select a Group'
    };

    if ( !this.editMode || this.duplicateMode ) {
      this.s2ClientOptions['multiple'] = true;
      this.s2GroupOptions['multiple'] = true;
    }

    this.subscription = this.elementService.elementChanged.subscribe(
      (element: Element) => {
        this.element = element;

        if ( this.editMode && typeof element.ID !== 'undefined' ) {
          this.htmlHolder = element.html;
          this.blockHolder = element.block_id;
          this.categoryHolder = element.category_id;

          this.elementService.httpGetElements(
            {
              parent_id: 0,
              category_id: element.category_id,
              block_id: element.block_id
            },
            '',
            ''
          );

          this.initFormEdit();
        }
      }
    );

    this.subscriptionResponse = this.elementService.elementOperation.subscribe(
      (element: Element) => {
        if ( typeof element.ID !== 'undefined' ) {
          this.loading = false;
          this.router.navigate([this.backUrl], {relativeTo: this.route});
        }
      }
    );

    this.subscriptionElements = this.elementService.elementsChanged.subscribe(
      (elements: Element[]) => {
        if (elements.length > 0) {
          this.elements = elements;
        }
      }
    );

    this.initForm();
  }

  private initForm() {
    this.elementForm = new FormGroup({
      'title': new FormControl('', Validators.required),
      'description': new FormControl(''),
      'provider': new FormControl('all', Validators.required),
      'group_id': new FormControl(this.s2GroupValue, Validators.required),
      'media_attribute_id': new FormControl('', Validators.required),
      'department_id': new FormControl(1, Validators.required),
      'client_id': new FormControl(this.s2ClientValue, Validators.required),
      'parent_id': new FormControl(0),
      'is_active': new FormControl(1, Validators.required),
      'icon': new FormControl(''),
      'thumbnail': new FormControl(''),
      'type': new FormControl('default', Validators.required),
      'listing_category': new FormControl(''),
      'sort': new FormControl('0'),
    });
  }

  private initFormEdit() {
    this.s2ClientValue = this.element.client_id;
    this.s2GroupValue = this.element.group_id;
    this.element_title = this.element.title;
    this.elementForm.patchValue({
      'title': this.element.title,
      'description': this.element.description,
      'group_id': this.s2GroupData,
      'provider': this.element.provider,
      'media_attribute_id': this.element.media_attribute_id,
      'department_id': this.element.department_id,
      'client_id': this.s2ClientValue,
      'parent_id': this.element.parent_id,
      'is_active': (this.duplicateMode) ? 0 : this.element.is_active,
      'icon': this.element.icon,
      'thumbnail': this.element.thumbnail,
      'type': this.element.type,
      'listing_category': this.element.listing_category,
      'sort': +('' + this.element.sort).substr(-5),
    });

    this.loading = false;
  }

  patchForm(field, value) {
    if (field === 'client_id') {
      this.elementForm.patchValue({'client_id': value});
      this.s2ClientValue = value;
    }
    if (field === 'group_id') {
      this.elementForm.patchValue({'group_id': value});
      this.s2GroupValue = value;
    }
  }

  onSubmit() {
    const elementValues = this.elementForm.value;

    const icon = this.fileIcon.nativeElement;
    const thumbnail = this.fileThumbnail.nativeElement;
    this.loading = true;

    if (icon.files.length > 0) {
      elementValues['iconFile'] = icon.files[0];
    }
    if (thumbnail.files.length > 0) {
      elementValues['thumbnailFile'] = thumbnail.files[0];
    }

    if (elementValues['type'] === 'default') {
      elementValues['parent_id'] = 0;
    }

    if ( this.editMode && typeof this.duplicateMode === 'undefined' ) {

      this.elementService.httpPutElement(this.id, elementValues);

    } else if (this.duplicateMode) {
      elementValues['element_duplicate_id'] = this.id;
      elementValues['category_id'] = this.categoryHolder;
      elementValues['block_id'] = this.blockHolder;

      this.elementService.httpPostElement(elementValues);
    } else {
      elementValues['category_id'] = this.category_id;
      elementValues['block_id'] = this.block_id;

      this.elementService.httpPostElement(elementValues);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionGroup.unsubscribe();
    this.subscriptionMediaAttribute.unsubscribe();
    this.subscriptionDepartment.unsubscribe();
    this.subscriptionClient.unsubscribe();
    this.subscriptionElements.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/templates/elements/element-edit/element-edit.component.ts